import { Order } from "@/types";
import AccordionMaterial from "./Accordions/AccordionMaterial";
import AccordionLogistics from "./Accordions/AccordionLogistics";
import AccordionGeneral from "./Accordions/AccordionGeneral";
import AccordionFinalAmount from "./Accordions/AccordionFinalAmount";
import AccordionOrderActions from "./Accordions/AccordionOrderActions";

interface DetailsTabProps {
  order: Order;
}

const DetailsTab = ({ order }: DetailsTabProps) => {
  return (
    <>
      <AccordionOrderActions order={order} />

      <AccordionGeneral order={order} />

      <AccordionMaterial order={order} />

      <AccordionLogistics order={order} />

      <AccordionFinalAmount order={order} />
    </>
  );
};

export default DetailsTab;
